import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Theme, ThemeState } from "./theme.type";

const initialState: ThemeState = {
  theme: {
    primaryColor: "#1976d2",
    secondaryColor: "#DCC6E7",
    tertiaryColor: "#fff",
    buttonsColor: "#292929",
    textColor: "#fff",
    fontFamily: "Manrope",
    lightColor: "#4b1849ad",
  },
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<Partial<Theme>>) => {
      state.theme = { ...state.theme, ...action.payload };
    },
    setColor: (state, action: PayloadAction<Partial<Theme>>) => {
      state.theme = { ...state.theme, ...action.payload };
    },
  },
});

export const { setTheme, setColor } = themeSlice.actions;
export default themeSlice.reducer;
